/** Figma `88960:41231` — layout + gap contract (excludes `88960:41250`). */
export const LOADING_STEP_FIGMA = {
  page: "88960:41231",
  background: "88963:41280",
  rippleDeco: "88963:41287",
  topBlock: "88960:41232",
  topNav: "88960:41236",
  backButton: "88960:41237",
  closeButton: "88328:5688",
  contentFrame: "89045:41978",
  contentBlock: "88963:41293",
  heroIcon: "88963:41286",
  iconHead: "88960:41246",
  iconBody: "88960:41247",
  titleBlock: "88960:41248",
  title: "88960:41249",
  excludedProgress: "88960:41250",
} as const;

/** Figma `89045:41978` — page y=193; minus status bar 37px → 156 when bar excluded. */
export const LOADING_STEP_LAYOUT = {
  contentLeft: 24,
  contentTop: 156,
  contentWidth: 345,
  iconToTitleGap: 64,
  statusBarHeight: 37,
  figmaContentTop: 193,
} as const;

/** Figma frame `88963:41280` → 393×852 webp (<150KB). */
export const LOADING_STEP_ASSETS = {
  background: "/assets/images/onboarding-loading/background.webp",
} as const;

/** 独立 `openLoadingOnboardingModal` / 未传 `backgroundSrc` 时的默认 Loading 背景 */
export const LOADING_STEP_DEFAULT_BACKGROUND_SRC =
  LOADING_STEP_ASSETS.background;

export const LOADING_STEP_ASSET_SIZE = {
  background: { width: 393, height: 852 },
} as const;

export const LOADING_TOKENS = {
  titleClass: "title_xxl text-content_inverse_primary",
  titleFontSize: "24px",
  titleLineHeight: "32px",
  titleWeight: "600",
  titleColor: "rgb(255, 255, 255)",
  iconColor: "rgb(243, 255, 134)",
  backBg: "rgb(255, 255, 253)",
} as const;
